export default __webpack_public_path__ + "static/media/Whyus2.02b9d6d7.jpg";